import Styled from "styled-components";

export type MordorBentoCardsBlockVariant =
  | "light"
  | "dark"
  | "darkAutodesigner"
  | "darkHomepage";

export interface ContainerProps {
  $variant: MordorBentoCardsBlockVariant;
}

export const Container = Styled.div<ContainerProps>`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }

  ${(props) =>
    props.$variant === "dark" &&
    `
    background: ${props.theme.colors.neutrals.black500};
  `}
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  overflow: hidden;
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export interface BentoCardsContainerProps {
  $variant: MordorBentoCardsBlockVariant;
}

export const BentoCardsContainer = Styled.div<BentoCardsContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    display: grid;
    align-items: flex-start;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 1.5rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto auto auto;

    ${(props) =>
      props.$variant === "dark" &&
      `
      grid-template-rows: 520px 416px 416px 436px;
    `}

    ${(props) =>
      props.$variant === "darkAutodesigner" &&
      `
      grid-template-rows: 480px 520px 570px;
    `}

    ${(props) =>
      props.$variant === "darkHomepage" &&
      `
      grid-template-rows: 520px 404px 436px;
    `}
  }
`;
